export default __webpack_public_path__ + "static/tradehome-14ccc9b55a117ae83aa02dea765c29b8.png";